import styled from "@emotion/styled";
import { Accordion } from "@mui/material";
import { PageHeader } from "components/Common/Page";

export const TrucksLandingPageHeader = styled(PageHeader)(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	boxSizing: "border-box",
	padding: "20px 32px",
	"& .MuiTabs-root": {
		minHeight: "42px",
		button: {
			minHeight: "42px",
			letterSpacing: ".4px"
		},
		"& .Mui-selected": {
			color: theme.project.colors.primaryColors.main
		},
		"& .MuiTabs-indicator": {
			backgroundColor: theme.project.colors.primaryColors.main
		}
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		padding: 16
	}
}));

export const TrucksLandingPageContent = styled.div(({ theme }) => ({
	padding: "16px 20px"
}));

export const OpenTrucksTableAccordion = styled(Accordion)(({ theme }) => ({
	"& .MuiAccordionSummary-root": {
		backgroundColor: theme.project.colors.allColors.hex.blue.light.lightBlue50,
		h6: {
			margin: 0,
			color: theme.project.colors.primaryColors.main
		},
		"& .MuiAccordionSummary-content": {
			margin: "8px 0"
		},
		svg: {
			color: theme.project.colors.primaryColors.main
		}
	},
	"& .MuiAccordionDetails-root": {
		padding: "16px"
	}
}));

export const OpenTrucksTableContainer = styled.div({
	overflowX: "auto",
	marginBottom: "16px"
});
